import { IOrderInitialState } from "./../../interfaces/order.interface";
import {
  IAccessControlUserInitialState,
  IAgentManagementInitialState,
  IAuthInitialState,
  ICampaignInitialState,
  ICategoryGlobalInitialState,
  ICategoryInitialState,
  ICnicVerificationInitialState,
  ICustomerInitialState,
  IDeliveryDateCreationState,
  IMetricsInitialState,
  INewsfeedInitialState,
  IPaiyaConfigCreationState,
  IPaiyaGiftInitialState,
  IProductCityLevelInitialState,
  IProductInitialState,
  IPromosCityLevelInitialState,
  IShipperInitialState,
  IStoreListingInitialState,
  IWarehouseStaffInitialState,
  IZonalConfigsInitialState,
  IZoneInitialState,
} from "../../interfaces/Index";

import { IBannerInitialState } from "../../interfaces/banner.interface";
import { IRiderInitialState } from "../../interfaces/riderManagement.interface";
import { IWarehouseOpsInitialState } from "../../interfaces/shiftDetail.interface";
import { ILiveOpsInitialState } from "interfaces/liveops.interface";
import { IAgentAssignmentInitialState } from "interfaces/agentAssignment.interface";

export const customersInitialState: ICustomerInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isCustomerAdded: false,
  isFetchCustomerLoading: false,
  isFetchCustomerError: false,
  customers: null,
  pagination: null,
  customerDetailsNew: null,
  bulkCustomerDetails: null,
  iscustomerDetailsNewFetched: false,
  customerZones: null,
  isBulkCustomerDetailsFetched: false,
  isCustomerUpdated: false,
  storeType: [],
  customerConfig: null,
  registrationType: false,
  incomeTaxStatus: false,
};

export const accessControlUsersInitialState: IAccessControlUserInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isAccessControlUserAdded: false,
  isAccessControlUserUpdated: false,
  accessControlUserDetailsNew: null,
  isaccessControlUserDetailsNewFetched: false,
  accessControlUsers: null,
  pagination: null,
  allClientsRoles: null,
  isAllClientsRolesFetched: false,
  isAllFiltersFetched: false,
  filters: null,
};

export const campaignInitialState: ICampaignInitialState = {
  isLoading: false,
  pagination: null,
  campaigns: [],
  isCampaignFetched: false,
  isCampaignFetchedError: false,
  isError: false,
  error: null,
  isCampaignCreated: false,
  isCampaignUpdated: false,
};

export const CnicVerificationInitialState: ICnicVerificationInitialState = {
  isLoading: false,
  pagination: null,
  cnicVerificationData: [],
  isCnicVerificationDataFetched: false,
  isCnicVerified: false,
  isCnicVerificationDataFetchedError: false,
  isError: false,
  error: null,
};
export const authInitialState: IAuthInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  auth: null,
  scopes: null,
  userInfo: null,
  mfa: null,
  isValidateMFASuccess: false,
  roles: [],
};

export const productInitilState: IProductInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isProductAdded: false,
  isFetchProductLoading: false,
  isFetchProductError: false,
  products: [],
  pagination: null,
  isProductUpdated: false,
  isProductBulkUploaded: false,
  isProductBulkUploading: false,
  isProductBulkUploadingError: false,
  isProductInventoryUploaded: false,
  isProductInventoryUploading: false,
  isProductInventoryUploadingError: false,
  productDetails: {},
  isProductDetailsFetched: false,
  productTypes: [],
  productUomList: [],
  productBrands: [],
  wareHouseNames: [],
  productInventory: null,
  isProductInventoryFetched: false,
  isProductInventoryUpdated: false,
  odooTax: null,
  isOdooTaxFetched: false,
  citiesList: [],
  productOptionalProperties: {},
};

export const categoryInitialState: ICategoryInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isCategoryAdded: false,
  isFetchCategoryLoading: false,
  isFetchCategoryError: false,
  categories: [],
  pagination: null,
  coreCategories: [],
  isCoreCategoriesFetched: false,
  isCategoryUpdated: false,
  isCategoryImageUploading: false,
  isCategoryImageUploaded: false,
  isCategoryProductsFetched: false,
  isCategoryProductsError: false,
  categoryProducts: [],
  isCategoryProductsUpdated: false,
};

export const orderInitialState: IOrderInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isOrderCreated: false,
  orders: [],
  pagination: null,
  isOrderUpdated: false,
  isFetchOrderLoading: false,
  isFetchOrderError: false,
  orderDetails: {},
  isOrderDetailsFetched: false,
  isOrderStatusUpdated: false,
  isPromosForOrderFetched: false,
  promosForOrder: null,
  orderPriceBreakdown: null,
  isOrderPriceBreakdownFetched: false,
  userCreditPlan: null,
  creditPaymentPlans: [],
  userCreditStatus: { status: "NOT_STARTED" },
};

export const promosCityLevelInitilState: IPromosCityLevelInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isPromoAdded: false,
  isFetchPromosLoading: false,
  isFetchPromosError: false,
  promosCityLevel: [],
  pagination: null,
  isPromoUpdated: false,
  promoDetails: {},
  isPromoDetailsFetched: false,
  isPromoByTypeFetched: false,
  isPromoByTypeFetchError: false,
  promosByType: [],
  typePromo: "",
  isWarehouseFetched: false,
  promoId: "",
  promoDescription: "",
  warehouseList: [],
  isUcFetched: false,
  ucList: [],
  //user level promo csv
  isUserLevelPromoCsvLoading: false,
  isUserLevelPromoCsvUploaded: false,
  isUserLevelPromoCsvError: false,
  userLevelPromoCsvError: null,
  userLevelPromoCsvFileName: "",
  userLevelPromoCsvFile: null,
};

export const agentManagementInitialState: IAgentManagementInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isAgentManagementUserAdded: false,
  isAgentManagementUserUpdated: false,
  agentManagementUserDetails: null,
  isagentManagementUserDetailsFetched: false,
  agentManagementUsers: null,
  pagination: null,
  allZones: null,
  isAllZonesFetched: false,
  agentTitle: [],
  agentTeam: [],
  brands: [],
};

export const storeListingInitilState: IStoreListingInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isFetchStoreListingLoading: false,
  isFetchStoreListingError: false,
  isStoreListingBulkUploaded: false,
  isStoreListingBulkUploading: false,
  isStoreListingBulkUploadingError: false,
};

export const shipperInitialState: IShipperInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isTourAssigned: false,
  isPlanAssigned: false,
  isCsvUploaded: false,
};

export const zoneInitialState: IZoneInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isCityListFetched: false,
  citiesList: [],
  retainedCity: null,
};

export const bannerInitialState: IBannerInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  banner: [],
  isBannerFetched: false,
  isBannerProductsFetched: false,
  isBannerAndProductsUpdated: false,
  isBannerSequenceUpdated: false,
};

export const productCityLevelInitialState: IProductCityLevelInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isProductCityLevelAdded: false,
  isFetchProductCityLevelLoading: false,
  isFetchProductCityLevelError: false,
  productsCityLevel: [],
  pagination: null,
  isProductCityLevelUpdated: false,
  isProductCityLevelBulkUploaded: false,
  isProductCityLevelBulkUploading: false,
  isProductCityLevelBulkUploadingError: false,
  isProductCityLevelInventoryUploaded: false,
  isProductCityLevelInventoryUploading: false,
  isProductCityLevelInventoryUploadingError: false,
  isNewCityLevelProductPricesUploaded: false,
  isNewCityLevelProductPricesUploading: false,
  isNewCityLevelProductPricesUploadingError: false,
  productCityLevelDetails: {},
  isProductCityLevelDetailsFetched: false,
  productCityLevelBrands: [],
  wareHouseNames: [],
  productCityLevelInventory: null,
  isProductCityLevelInventoryFetched: false,
  isProductCityLevelInventoryUpdated: false,
  odooTax: null,
  isOdooTaxFetched: false,
  citiesList: [],
  deliveryOptions: [],
};

export const categoryGlobalInitialState: ICategoryGlobalInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isCategoryGlobalAdded: false,
  isFetchCategoryGlobalLoading: false,
  isFetchCategoryGlobalError: false,
  categoriesGlobal: [],
  pagination: null,
  coreCategories: [],
  isCoreCategoriesFetched: false,
  isCategoryGlobalUpdated: false,
};

export const categoryCityLevelInitialState: ICategoryGlobalInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isCategoryGlobalAdded: false,
  isFetchCategoryGlobalLoading: false,
  isFetchCategoryGlobalError: false,
  categoriesGlobal: [],
  pagination: null,
  coreCategories: [],
  isCoreCategoriesFetched: false,
  isCategoryGlobalUpdated: false,
};

export const riderInitialState: IRiderInitialState = {
  isRiderManagementUserAdded: false,
  isEdit: false,
  dummyValidation: false,
  isLoading: false,
  isError: false,
  error: null,
  isRiderListFetched: false,
  riders: [],
  pagination: null,
  isRiderUserDetailsFetched: false,
  riderUserDetails: null,
  isRiderUpdated: false,
  isRiderCreated: false,
  locusCsvFile: null,
  isCsvDownloaded: false,
  riderTypes: {
    jobTypes: [],
    subTypes: [],
  },
  warehousesList: [],
};

export const warehouseOpsInitialState: IWarehouseOpsInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isWarehouseShiftStarted: false,
  warehouseShiftId: null,
  isTourAdded: false,
  isTourCsvUploaded: false,
  isWarehouseShiftEnded: false,
  isShiftEnded: false,
};

export const zonalConfigsInitilState: IZonalConfigsInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isZonalConfigAdded: false,
  isFetchZonalConfigsLoading: false,
  isFetchZonalConfigsError: false,
  zonalConfigs: [],
  pagination: null,
  isZonalConfigUpdated: false,
  isZonalConfigDetailsFetched: false,
  isZonalConfigByTypeFetched: false,
  isZonalConfigByTypeFetchError: false,
  warehouseCategories: [],
  isWarehouseCategoriesFetched: false,
  zonalConfigChildZones: [],
  isZonalConfigChildZonesFetched: false,
  zonalConfigTowns: [],
  isZonalConfigTownsFetched: false,
  isZonalConfigWarehouseNameFetched: false,
  zonalConfigWarehouseName: {},
  zonalConfigChannelName: null,
  isFetchCustomerChannelLoading: false,
};

export const deliveryDateInitialState: IDeliveryDateCreationState = {
  isLoading: false,
  isError: false,
  error: null,
  isEdit: false,
  isWarehouseConfigAdded: false,
  orderReceivedStartTime: "",
  orderReceivedEndTime: "",
  expectedDeliveryAt: "",
  warehouseId: "",
  status: "",
  warehouseCategories: [],
  isWarehouseCategoriesFetched: false,
  isFetchWarehouseDeliveryDateConfig: false,
  warehouseDeliveryDateConfig: null,
};

export const paiyaConfigInitialState: IPaiyaConfigCreationState & { [key: string]: any } = {
  isLoading: false,
  isError: false,
  error: null,
  isEdit: false,
  cityId: "",
  paiyaId: "",
  paiyaTypesList: [],
  paiyaConfig: null,
  isPaiyaTypesFetched: false,
  isPaiyaConfigAdded: false,
  isPaiyaConfigFetch: false,
  //gift csv
  isGiftCsvLoading: false,
  isGiftCsvUploaded: false,
  isGiftCsvError: false,
  giftCsvError: null,
  giftCsvFileName: "",
  giftCsvFile: null,

  //store csv
  isStoreCsvLoading: false,
  isStoreCsvUploaded: false,
  isStoreCsvError: false,
  storeCsvError: null,
  storeCsvFileName: "",
  storeCsvFile: null,

  //mov, game status
  mov: "1000",
  status: "",
  isMovStatusLoading: false,
  isMovStatusUploaded: true,
  movStatusError: null,
};

export const metricsInitialState: IMetricsInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isMetricsUpdated: false,
  metricsDetails: null,
  isMetricsDetailsFetched: false,
  metricsDetailsFetched: null,
  isCoreMetricsFetched: false,
  coreMetricsFetched: [],
  isCategoriesMetricsFetched: false,
  categoriesMetrics: [],
  isMetricsUploading: false,
  isMetricsUploadingError: false,
  isMetricsUploaded: false,
};

export const warehouseStaffInitialState: IWarehouseStaffInitialState = {
  staff: [],
  isLoading: false,
  isError: false,
  error: null,
  isWarehouseStaffListFetched: false,
  pagination: null,
  isWarehouseStaffUserDetailsFetched: false,
  warehouseStaffUserDetails: {},
  isWarehouseStaffUserAddUpdate: false,
  isWarehouseStaffUpdated: false,
  isWarehouseStaffCreated: false,
  warehouseList: [],
  jobTypesList: [],
};

export const newsfeedInitialState: INewsfeedInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isNewsfeedListFetched: false,
  newsfeedListFetched: [],
  isFetchNewsfeedError: false,
};

export const liveOpsInitialState: ILiveOpsInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  deliveryDateUpdated: false,
};

export const agentAssignmentInitialState: IAgentAssignmentInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  agentChatwootAssignmentCompleted: false,
  agentStoreAssignmentCompleted: false,
};

export const paiyaGiftInitialState: IPaiyaGiftInitialState = {
  isLoading: false,
  isError: false,
  error: null,
  isPaiyaGiftsFetched: false,
  isPaiyaGiftCreated: false,
  paiyaGifts: [],
};
